import _ from 'lodash';
import moment from 'moment';
import * as Yup from 'yup';
import {
  IS_LOGIN_ACTION,
  LOGIN_INFO,
  REFRESH_TOKEN_MINUTE,
  WARD_INFO,
  ACCESS_TOKEN_MINUTE,
  NOTIFICATION_MESSAGE,
} from '../comm/constant';
import rou from '../router';
import autoApi from '../apis/authenticate/index';
import { store } from '../redux';
import {
  updateLoginInfoAction,
  updateWardinfoAction,
  expiryLoginPopUpOpen,
  expiryLoginPopUpClose,
} from '../redux/actions';
import { getRouterRef } from './router';
import { userRoleFunc, userRoleList } from './userRole';
import { mutationUpdateOtherLoginInfo } from './handleUpdateOtherLoginInfo';
import { authNameE } from './userFuncs';
import { getRandomNum } from './randomUtil';
import { getUserInfo } from '.';

const checkIsNewDrive = (userRole, routerList) => {
  const localWard = localStorage.getItem(WARD_INFO);
  const localLogin = localStorage.getItem(LOGIN_INFO);
  const ssoLogin = sessionStorage.getItem('SSO_LOGIN');

  if (ssoLogin) {
    return;
  }

  if (!localWard && !localLogin) {
    // 沒登陸沒初始化電腦
    getRouterRef().push(rou.loginRou.path);
  } else if (!localWard && userRole) {
    // 登陸沒初始化電腦
    const loginObj = JSON.parse(localLogin);
    const role = userRoleList.getHospWard(userRole, loginObj.hospitalId, loginObj.wardId, loginObj.userId);
    if (userRoleFunc.isSuperAdmin(role) || (userRoleFunc.isHospitalAdmin(role) && userRoleFunc.isWardEmpty(role))) {
      // 是super admin 或者 hospital admin 没有ward
      if (isLoginAction()) {
        getRouterRef().push(defauleSkipUrlRole());
        cacelLoginAction();
      }
    } else {
      // 不是super admin 或者 hospital admin 没有ward, 去setup
      getRouterRef().push(rou.setupRou.path);
    }
  }
  // 初始化電腦，沒登陸 或者 初始化電腦，有登陸
  else if (isLoginAction()) {
    // 非url輸入進入的
    LogOutAndLoginInRedirectUrl(userRole, routerList);
    cacelLoginAction();
  }
};

const isLoginAction = () => {
  return sessionStorage.getItem(IS_LOGIN_ACTION);
};

const cacelLoginAction = () => {
  sessionStorage.removeItem(IS_LOGIN_ACTION);
};

const addLoginAction = () => {
  sessionStorage.setItem(IS_LOGIN_ACTION, true);
};

const LogOutAndLoginInRedirectUrl = (userRole, routerList) => {
  const skipUrl = urlCheckAndSkip(getRouterRef().location.pathname, routerList, getRouterRef().location.search);
  getRouterRef().replace(skipUrl);
};

const defauleSkipUrlRole = () => {
  return rou.defaultRou.path;
};

const urlCheckAndSkip = (url, routerList, search) => {
  const matchRoute = (path, url) => {
    if (!path) {
      return false;
    }
    const escapedPath = path.replace(/([.*+?^${}()|[\]\\])/g, '\\$1'); // 转义特殊字符
    const pathRegex = new RegExp(`^${escapedPath.replace(/:[^/]+/g, '[^/]+')}$`);
    return pathRegex.test(url);
  };

  const result = _.find(routerList, (item) => {
    return matchRoute(item.path, url);
  });
  return result ? url + search : rou.defaultRou.path;
};

const rewriteRequestHeaders = (headers) => {
  const newHead = { ...headers };
  if (userRoleList.isSuperAdminUseGlobleTypeId()) {
    delete newHead['x-HospitalId'];
  }
  if (userRoleList.isSAorHAUseGlobleTypeId()) {
    delete newHead['x-WardId'];
  }
  return newHead;
};

const rewriteRequestParams = (params) => {
  const state = store.getState();
  const { loginInfo } = state;
  const ids = getUserInfo();
  const nweParams = { ...params };
  if (nweParams.wardId === undefined) {
    nweParams.wardId = ids.wardId;
  }
  if (nweParams.hospId === undefined) {
    nweParams.hospId = ids.hospId ?? loginInfo?.hospitalId;
  }
  return nweParams;
};

const rewriteSettingRequestParams = (params) => {
  const ids = getUserInfo();
  const nweParams = { ...params };
  if (!nweParams?.hospId) {
    if (userRoleList.isSuperAdminUseGlobleTypeId()) {
      nweParams.hospId = null;
    } else {
      nweParams.hospId = ids.hospId;
    }
  }
  if (!nweParams?.wardId) {
    if (userRoleList.isSAorHAUseGlobleTypeId()) {
      nweParams.wardId = null;
    } else {
      nweParams.wardId = ids.wardId;
    }
  }
  return nweParams;
};

const checkLocalStroage = () => {
  try {
    const localLogin = localStorage.getItem(LOGIN_INFO);
    if (localLogin && JSON.parse(localLogin).userId === undefined) {
      localStorage.removeItem(LOGIN_INFO);
      mutationUpdateOtherLoginInfo();
      localStorage.removeItem(WARD_INFO);
    }
  } catch {
    localStorage.removeItem(LOGIN_INFO);
    mutationUpdateOtherLoginInfo();
    localStorage.removeItem(WARD_INFO);
    window.location.reload();
  }
};

const expiryLoginCancel = () => {
  try {
    if (checkForceResetWard()) {
      resetWard();
      return;
    }
    localStorage.removeItem(LOGIN_INFO);
    mutationUpdateOtherLoginInfo();
    const wardinfo = JSON.parse(localStorage.getItem(WARD_INFO));
    store.dispatch(updateLoginInfoAction({ flag: false, ...wardinfo }));
    store.dispatch(expiryLoginPopUpClose());
  } catch {
    localStorage.removeItem(LOGIN_INFO);
    mutationUpdateOtherLoginInfo();
    localStorage.removeItem(WARD_INFO);
    window.location.reload();
  }
};

const tokenInvalid = (warmLostInput) => {
  if (isSessionValid()) {
    store.dispatch(expiryLoginPopUpOpen(warmLostInput));
  }
};

const userInActive = (warmLostInput) => {
  tokenInvalid(warmLostInput);
};

const genLocalLockVal = () => {
  return Date.now().toString() + getRandomNum().toString();
};

const lockLocalStorage = (lockKey, lockVal) => {
  const acquiredLock = localStorage.getItem(lockKey) === lockVal;
  if (!acquiredLock) {
    localStorage.setItem(lockKey, lockVal);
  }
  return acquiredLock;
};

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
const mutex = {
  isLocked: false,
  queue: [],

  lock: function (lockKey) {
    const that = this;
    return new Promise((resolve) => {
      async function innerLock() {
        if (that.isLocked) {
          // If the mutex is already locked, add the resolver function to the queue
          that.queue.push(resolve);
        } else {
          // If the mutex is not locked, resolve immediately

          that.isLocked = true;
          const lockVal = genLocalLockVal();
          let acquiredLock = lockLocalStorage(lockKey, lockVal);
          const MAX_TRIAL = 6;
          let trail = 0;
          while (!acquiredLock && trail < MAX_TRIAL) {
            await sleep(500);
            trail++;
            acquiredLock = lockLocalStorage(lockKey, lockVal);
          }
          localStorage.setItem(lockKey, lockVal); // force lock
          resolve();
        }
      }
      innerLock();
    });
  },

  unlock: function (lockKey) {
    if (this.queue.length > 0) {
      // If there are functions waiting in the queue, shift the first one and execute it
      const next = this.queue.shift();
      next();
    } else {
      // If there are no waiting functions, unlock the mutex
      localStorage.removeItem(lockKey);
      this.isLocked = false;
    }
  },
};

const checkToken = async (isHideLoading = true, isHideError = false) => {
  const lockKey = 'checkTokenLocalStorageLock';
  try {
    await mutex.lock(lockKey);
    let isRefreshCheck = false;
    const currentState = store.getState();
    const loginInfoInRedux = currentState.loginInfo;
    try {
      const loginInfo = JSON.parse(localStorage.getItem(LOGIN_INFO));

      if ((loginInfo?.corpID ?? '').toUpperCase() !== (loginInfoInRedux?.corpID ?? '').toUpperCase()) {
        return false;
      }

      if (loginInfo === null) {
        return false;
      }
      const { token, refreshToken: refToken, refreshTokenExp } = loginInfo;

      const { isVerified } = await autoApi.verifyToken({ token }, { isHideLoading, isHideError });
      const minuteNum = moment(refreshTokenExp).diff(moment(), 'minute');
      let needToRefresh = false;
      isRefreshCheck = isVerified;
      let needToRefreshLoginInfoInRedux =
        loginInfo.hospitalId !== loginInfoInRedux.hospitalId || loginInfo.wardId !== loginInfoInRedux.wardId;

      needToRefresh =
        (!isVerified && minuteNum > 0) ||
        (isVerified && minuteNum < REFRESH_TOKEN_MINUTE - ACCESS_TOKEN_MINUTE + 3) ||
        needToRefreshLoginInfoInRedux;
      // access token is expiry and can refresh token. or, access token is valid but will be expired

      if (needToRefresh) {
        const { token, tokenExp, refreshToken, refreshTokenExp } = await autoApi.refreshToken(
          {
            refreshToken: refToken,
          },
          { isHideLoading, isHideError }
        );
        localStorage.setItem(
          LOGIN_INFO,
          JSON.stringify({ ...loginInfo, token, tokenExp, refreshToken, refreshTokenExp })
        );
        if (needToRefreshLoginInfoInRedux) {
          store.dispatch(updateLoginInfoAction({ ...loginInfo, token, tokenExp, refreshToken, refreshTokenExp }));
        }
        isRefreshCheck = true;
      }
    } catch (e) {
      console.log(e);
    }

    return isRefreshCheck;
  } finally {
    mutex.unlock(lockKey);
  }
};

const checkSubmitData = async (schema, data) => {
  try {
    await schema.validate(data, {
      abortEarly: false,
    });
  } catch (err) {
    const validationErrors = {};
    _.forEach(schema?._nodes, (item) => {
      validationErrors[item] = null;
    });
    if (err instanceof Yup.ValidationError) {
      err.inner.forEach((error) => {
        if (error.path !== undefined) {
          validationErrors[error.path] = error.message;
        }
      });
    }
    throw validationErrors;
  }
};

const isSessionValid = () => {
  const currentState = store.getState();
  const loginInfoInRedux = currentState.loginInfo;
  const expiryLoginState = currentState.expiryLogin;
  return loginInfoInRedux.flag && !expiryLoginState.isOpen;
};

const checkAndLoginIfInactive = async () => {
  if (isSessionValid) {
    const result = await checkToken(true, false);
    if (!result) {
      userInActive(false);
    }
    return result;
  } else {
    return false;
  }
};

const checkForceResetWard = () => {
  const userInfo = getUserInfo();
  const state = store.getState();
  let forceReset = false;
  if (state && state.roleMap) {
    forceReset = state.roleMap[authNameE.logout_control];
  }

  return userInfo && forceReset;
};

const resetWard = () => {
  localStorage.removeItem(WARD_INFO);
  localStorage.removeItem(LOGIN_INFO);
  mutationUpdateOtherLoginInfo();
  localStorage.removeItem(NOTIFICATION_MESSAGE);
  store.dispatch(updateWardinfoAction(false, '', '', null, null));
  store.dispatch(updateLoginInfoAction({ flag: false }));
};

const checkRedirectUrl = () => {
  const localWard = localStorage.getItem(WARD_INFO);
  if (!localWard && window.location.pathname === '/patientSurveyDetail') {
    sessionStorage.setItem('REDIRECT_URL', `${window.location.pathname}${window.location.search}`);
  }
};

const loginAndRedirect = () => {
  const path = sessionStorage.getItem('REDIRECT_URL');
  if (path) {
    getRouterRef().push(path);
  }
};

const clearRedirectUrl = () => {
  sessionStorage.removeItem('REDIRECT_URL');
};

export {
  checkIsNewDrive,
  urlCheckAndSkip,
  LogOutAndLoginInRedirectUrl,
  addLoginAction,
  cacelLoginAction,
  isLoginAction,
  defauleSkipUrlRole,
  rewriteRequestHeaders,
  rewriteRequestParams,
  rewriteSettingRequestParams,
  checkLocalStroage,
  tokenInvalid,
  checkToken,
  checkSubmitData,
  userInActive,
  expiryLoginCancel,
  isSessionValid,
  checkAndLoginIfInactive,
  checkForceResetWard,
  resetWard,
  checkRedirectUrl,
  loginAndRedirect,
  clearRedirectUrl,
};
